import { useLocation } from "react-router-dom";
import ExtractAnalysisV1 from "./ExtractAnalysisV1";
import ExtractAnalysisV2 from "./ExtractAnalysisV2";

const ExtractAnalysis = () => {
  const location = useLocation();
  const { selectedYear } = (location.state ?? {}) as { selectedYear?: number };

  if (Number(selectedYear) > 2025) return <ExtractAnalysisV2 />;
  return <ExtractAnalysisV1 />;
};

export default ExtractAnalysis;
